// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"255":"d2b2a8a9","293":"c51435d7","743":"b1a9a12c","887":"5d843876"}[chunkId] + ".css";
};